import { render, staticRenderFns } from "./BlockSubGroup2HelpList.vue?vue&type=template&id=575c67b1&"
import script from "./BlockSubGroup2HelpList.vue?vue&type=script&lang=js&"
export * from "./BlockSubGroup2HelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports